//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { listCurations } from '@/api/free-elements.js';

export default {
  name: 'FreePartnerCurations',
  components: {
    BaseImg: () => import('@motionelements/core/src/components/ui/BaseImg.vue'),
    BiographyCard: () => import('@/components/free//BiographyCard.vue'),
    FreeCurationsButtons: () => import('@/components/free/FreeCurationsButtons.vue'),
    FreeProducts: () => import('@/components/free/FreeProducts.vue'),
  },
  props: {
    partnerId: {
      type: String,
      default: null,
    },
    mediaTypeId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      curations: [],
      currentCuration: null,
    };
  },
  computed: {
    partnerData() {
      if (this.partnerId === 'pakutaso') {
        switch (this.$i18n.locale) {
          case 'ja':
            return {
              title: 'スペシャル<wbr>コラボ<wbr>企画！人気<wbr>モデルが<wbr>無料<wbr>ダウンロード',
              logo: 'https://static.moele.me/img/free/pakutaso/pakutaso-logo.png',
              // description: 'フリー写真素材の<wbr>PAKUTASOと<wbr>人気モデルの<wbr>河村友歌をお迎えし、<wbr>すぐに使えるアルファ付き（背景透明）<wbr>動画素材を製作しました。 ',
              bios: [
                {
                  photo: 'https://static.moele.me/img/free/pakutaso/thumb-pakutaso.jpg',
                  title: 'PAKUTASO',
                  description: 'ぱくたそは月間400万PVの日本のストックフォトサービスです。「使って楽しい、見て楽しい」をキャッチコピーに、高品質・高解像度の写真素材を無料で配布しています。',
                  backlink: {
                    url: 'https://www.pakutaso.com',
                  },
                  info: 'また個人ページとして他にも多数の動画素材を販売中です。',
                  artist: 'susipaku',
                },
                {
                  photo: 'https://static.moele.me/img/free/pakutaso/thumb-yuka.jpg',
                  title: 'モデル: 河村友歌',
                  description: 'ぱくたそのフリー素材モデルとして活躍している現役大学生の河村友歌（かわむらゆか）です。フリー素材では、様々なシチュエーションにチャレンジし広告やメディアなどに取り上げられています。',
                  backlink: {
                    url: 'https://www.pakutaso.com/kawamurayuka.html',
                  },
                },
                {
                  photo: 'https://static.moele.me/img/free/pakutaso/thumb-hiroko.jpg',
                  title: 'モデル: 土本寛子',
                  description: 'ライター職をメインに、職種にこだわりなく仕事しています。ゴールを共有してプロジェクト型に仕事するのって楽しい！ お手伝いできそうなことがあればぜひご連絡ください。',
                  backlink: {
                    url: 'https://www.pakutaso.com/hiroko_tsuchi.html',
                  },
                },
              ],
            };
          case 'zh-hant':
            return {
              title: '特別聯名計畫！ 人氣模特兒素材免費下載',
              logo: 'https://static.moele.me/img/free/pakutaso/pakutaso-logo.png',
              // description: '我們和日本人氣模特兒 河村友歌 共同製作和拍攝一系列的Alpha色版去背的4K綠幕影片，這些高品質素材將提供免費下載 - 只有在限定時間內，連續四週每週都將有不同的影片素材可供免費下載，千萬別錯過！',
              bios: [
                {
                  photo: 'https://static.moele.me/img/free/pakutaso/thumb-pakutaso.jpg',
                  title: 'PAKUTASO',
                  description: 'Pakutaso 是日本的高人氣相片素材網站，每月高400萬瀏覽數， “開心地使用、開心地觀賞” ，是他們免費提供高品質、高解析度照片素材的宗旨。',
                  link: 'https://www.pakutaso.com',
                  info: '其他精選影片素材也能在他的個人頁面購買下載。',
                  artist: 'susipaku',
                },
                {
                  photo: 'https://static.moele.me/img/free/pakutaso/thumb-yuka.jpg',
                  title: 'Model: Yuka Kawamura',
                  description: '河村友歌現為大學生也同時是位廣告模特兒，她擁有多個媒體廣告的拍攝經驗，能自然地展現出各種的情緒與動作。',
                  link: 'https://www.pakutaso.com/kawamurayuka.html',
                },
                {
                  photo: 'https://static.moele.me/img/free/pakutaso/thumb-hiroko.jpg',
                  title: 'Model: Hiroko Tsuchimoto',
                  description: '土本寬子主業是作家，但仍嘗試挑戰各種不同類型的工作。 ”我非常享受專案團隊工作中和其他成員一起為共同目標努力的感覺。如果對我有興趣的話，歡迎與我聯絡。“',
                  link: 'https://www.pakutaso.com/hiroko_tsuchi.html',
                },
              ],
            };
          default:
            return {
              title: 'Special Collaboration! Popular Japanese model free download',
              logo: 'https://static.moele.me/img/free/pakutaso/pakutaso-logo.png',
              // description: 'We co-produced and filmed a new series of Pre-keyed with Alpha channel 4K Greenscreen Videos with popular Japanese model Yuka Kawamura from Pakutaso. We are providing these videos Free for Download - for a limited time only! We are offering you a different set of free videos each week. Don\'t miss out on any week!',
              bios: [
                {
                  photo: 'https://static.moele.me/img/free/pakutaso/thumb-pakutaso.jpg',
                  title: 'PAKUTASO',
                  description: 'Pakutaso is a stock photo service in Japan with monthly 4 million PV. "Fun to use, fun to watch", is the catch copy and distribution of high-quality, high-resolution photo material is free of charge.',
                  link: 'https://www.pakutaso.com',
                  info: 'A selection of other video material is also available for sale on his individual page.',
                  artist: 'susipaku',
                },
                {
                  photo: 'https://static.moele.me/img/free/pakutaso/thumb-yuka.jpg',
                  title: 'Model: Yuka Kawamura',
                  description: 'Yuka is a University student and freelance model. She has experience with various media and advertising formats and is a versatile talent capable of delivering in a variety of actions and situations.',
                  link: 'https://www.pakutaso.com/kawamurayuka.html',
                },
                {
                  photo: 'https://static.moele.me/img/free/pakutaso/thumb-hiroko.jpg',
                  title: 'Model: Hiroko Tsuchimoto',
                  description: 'Hiroko is a writer by profession but is open to exploring different types of work. She particularly enjoys working together as a team in a project - collaborating and achieving goals with other team members. She welcomes you to contact her for any work related opportunities.',
                  link: 'https://www.pakutaso.com/hiroko_tsuchi.html',
                },
              ],
            };
        }
      }
      return {};
    },
    title() {
      return _.get(this.partnerData, 'title');
    },
    logo() {
      return _.get(this.partnerData, 'logo');
    },
    description() {
      return _.get(this.partnerData, 'description');
    },
    bios() {
      return _.get(this.partnerData, 'bios') || [];
    },
  },
  created() {
    if (this.partnerId) {
      listCurations({
        partner: this.partnerId,
      })
        .then((response) => {
          this.curations = response.data.data.map(curation => ({
            id: curation.heading,
            ...curation,
          }));
          this.currentCuration = response.data.data[0].id;
        })
        .catch((e) => {
          console.warn(e);
        });
    }
  },
};
